import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useState } from "react";

export default function ImpersonationBanner() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [exiting, setExiting] = useState(false);

  if (!user || !user.impersonating) return null;

  const stop = async () => {
    setExiting(true);
    try {
      await api.post("/admin/stop-impersonation");
      await refresh();
      toast.success("Back to admin console");
      navigate("/admin");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setExiting(false);
    }
  };

  return (
    <div
      className="sticky top-0 z-[100] bg-[#E13C32] text-white py-2 px-4 flex items-center justify-between gap-4"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-3 min-w-0 flex-1">
        <ShieldAlert className="w-5 h-5 flex-shrink-0" />
        <div className="text-sm min-w-0 truncate">
          <span className="font-label mr-2">IMPERSONATION ACTIVE</span>
          You are signed in as <span className="font-display tracking-wide">{user.name}</span> ({user.email})
          {user.company_name && <span className="opacity-80"> at {user.company_name}</span>}.
          Every action is logged.
        </div>
      </div>
      <button
        onClick={stop}
        disabled={exiting}
        className="flex items-center gap-2 bg-black/30 hover:bg-black/50 transition-colors px-3 py-1 rounded-sm font-label text-xs disabled:opacity-50"
        data-testid="stop-impersonation-button"
      >
        {exiting ? <Loader2 className="w-3 h-3 animate-spin" /> : <X className="w-3 h-3" />}
        Return to admin console
      </button>
    </div>
  );
}
